import { Expose } from "class-transformer";

export class AddValuationProjectsDto {
  @Expose()
  valuationId: string;

  @Expose()
  projectIds: string[];
}
